export const identityMigrations = [
  {
    id: '038_identity_verification_documents',
    sql: `
      CREATE TABLE IF NOT EXISTS identity_verification_submissions (
        id UUID PRIMARY KEY,
        user_id UUID NOT NULL UNIQUE REFERENCES users(id) ON DELETE CASCADE,
        front_image_encrypted TEXT,
        back_image_encrypted TEXT,
        status TEXT NOT NULL DEFAULT 'reviewing'
          CHECK (status IN ('reviewing', 'verified', 'rejected')),
        admin_note TEXT NOT NULL DEFAULT '',
        submitted_at TIMESTAMPTZ NOT NULL DEFAULT NOW(),
        reviewed_at TIMESTAMPTZ,
        reviewed_by UUID REFERENCES users(id) ON DELETE SET NULL,
        updated_at TIMESTAMPTZ NOT NULL DEFAULT NOW()
      );
      CREATE INDEX IF NOT EXISTS identity_verification_review_idx
        ON identity_verification_submissions(status, submitted_at DESC);
    `,
  },
] as const;
